import React from 'react';
import AppReact from "./App.jsx"

function App() {
  return (
    <div className="App">
      <AppReact/>
    </div>
  );
}

export default App; 